import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";
import {PaymentPlan} from "../../entities/PaymentPlan.ts";

export class GetAgencyPaymentPlansUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    async execute(agencyId: string): Promise<PaymentPlan[]> {
        return this.agencyRepository.getPaymentPlans(agencyId)
    }
}
